import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
    const navigate = useNavigate();
    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '24px',
                textAlign: 'center',
                padding: '40px 20px',
                background: 'var(--color-bg)',
                color: 'var(--color-text)',
            }}
        >
            <span
                style={{
                    fontSize: '96px',
                    fontWeight: 700,
                    color: 'var(--color-primary)',
                    lineHeight: 1,
                }}
            >
                404
            </span>
            <h1 style={{ margin: 0, fontSize: '28px', fontWeight: 600 }}>
                Page Not Found
            </h1>
            <p style={{ margin: 0, color: 'var(--color-text-secondary)', maxWidth: '380px' }}>
                The page you're looking for doesn't exist or has been moved.
            </p>
            <button
                className="cta-button cta-primary"
                onClick={() => navigate('/')}
            >
                ← Back to Portfolio
            </button>
        </div>
    );
}
